import React, { Dispatch, SetStateAction } from 'react'
import { DomainTableRow } from './DomainRowTable'
import { DomainToServer } from 'Types/Domain'
import { Products } from 'Types/Product'
import useAddDomainStore from '../store/addDomainsStore'

interface DomainsTableBodyProps {
  searchText: string
  blockedDomains: Array<Products | undefined>
  handleSetProducts: (
    address: string
  ) => (products: { paidMarketing?: boolean; botZapping?: boolean }) => void
  setSelectAll: Dispatch<SetStateAction<boolean>>
}

export const DomainsTableBody = ({
  blockedDomains,
  searchText,
  handleSetProducts,
  setSelectAll,
}: DomainsTableBodyProps) => {
  const { domainsLeft, productsLeft, allDomainsInTable, setAllDomainsInTable } = useAddDomainStore()

  const filteredDomains: DomainToServer[] = allDomainsInTable.filter((domain) =>
    domain.address.includes(searchText)
  )

  const handleCheckboxChange = (address: string, value: boolean) => {
    if (!value) setSelectAll(false)
    // If isRelevantDomain and the value is false, reset the products to false
    // Else, add available products
    setAllDomainsInTable(
      allDomainsInTable.map((domain) => {
        const isRelevantDomain = domain.address === address
        return isRelevantDomain
          ? {
              address: domain.address,
              selected: !!domainsLeft && value,
              botZapping: !!productsLeft.botZapping && value,
              paidMarketing: !!productsLeft.paidMarketing && value,
            }
          : domain
      })
    )
  }

  return (
    <>
      {filteredDomains.map((domain) => (
        <DomainTableRow
          key={domain.address}
          domain={domain}
          blockedDomains={blockedDomains}
          handleCheckboxChange={handleCheckboxChange}
          handleSetProducts={handleSetProducts}
        />
      ))}
    </>
  )
}
